import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { CardOffersView, EdCardOffersApi } from '../tokens/ed-card-offers.token';

/**
 * REST implementation of the E-D Card Offers API (PRD §3.6/§1.9, EM-836).
 *
 *   GET /services/embedded/api/v1/ed/card-offers
 *
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_CARD_OFFERS.
 */
@Injectable({ providedIn: 'root' })
export class EdCardOffersRestService implements EdCardOffersApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/card-offers`;

  getCardOffers(): Observable<CardOffersView> {
    return this.http.get<CardOffersView>(this.base);
  }
}
